import { InjectionToken } from '@angular/core';
import { BaseDataSource } from 'eurogard-data-source';
import { PaginatorLike } from './abstract-pagination.data-source';

export const RXAP_PAGINATION_DATA_SOURCE = new InjectionToken<BaseDataSource<any[]>>(
  'eurogard-data-source/pagination/source');
export const RXAP_PAGINATION_DATA_SOURCE_PAGINATOR = new InjectionToken<PaginatorLike>(
  'eurogard-data-source/pagination/paginator');
